import { cn } from '@/common/utils/cn'
import { RewardLedgerEntryData } from '@/features/tmaisUsers/types/rewardLedgerEntries.type'
import { CardInfoCell } from './CardInfoCell'
import { CardWrapper } from './CardWrapper'

interface ConsumptionCardProps {
  entry: RewardLedgerEntryData
}

export const ConsumptionCard = ({ entry }: ConsumptionCardProps) => {
  const isNegative = parseFloat(entry.quantity_earned) < 0

  return (
    <CardWrapper entry={entry}>
      <div className="grid grid-cols-1 gap-2">
        <CardInfoCell label="Pontos">
          <img src="/TCoinPoint.svg" alt="TCoinPoint" className="size-4" />

          <span
            className={cn('text-sm', {
              'text-danger-soft': isNegative,
            })}
          >
            {Number(entry.quantity_earned ?? 0)}
          </span>
        </CardInfoCell>
      </div>
    </CardWrapper>
  )
}
